module.exports = __webpack_public_path__ + "static/media/15UN-Habitat4.d460d6a6.jpg";